import React, { useState } from "react";
import "../enquire/sortandfilter/SearchAndFilter.css";
import AbstractButton from "../components/AbstractButton";
import "../enquire/sortandfilter/EditSortBy.css";
import { ReactComponent as CancelIcon } from "../../assets/icons/backspace-20-regular.svg?react";
import { ReactComponent as OkayIcon } from "../../assets/icons/checkbox-checked-sync-regular.svg?react";
import ForegroundColorSet from "../../utilities/enums/ForegroundColorSet";
import BackgroundColorSet from "../../utilities/enums/BackgroundColorSet";
import { StockCheckLinesSearch } from "../../interfaces/SceSearch";
import { OrderDirection, Inclusivity } from "../../interfaces/PartSearch";
import InclusivitySelector from "../enquire/sortandfilter/InclusivitySelector";
import { Slide, toast, ToastContainer } from "react-toastify";

interface SearchAndFilterProps {
  searchData: StockCheckLinesSearch;
  visibilityClassName: string;
  onShowTrigger: number;
  onCancelCallback(): void;
  onOkayCallback(Data: StockCheckLinesSearch): void;
}
const StockCheckLineFilter = (props: SearchAndFilterProps) => {
  const [searchData, setSearchData] = useState(props.searchData);
  const [isValidInput, setisValidInput] = useState(true);

  const handleDirectionChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setSearchData({
      ...searchData,
      OrderDirection: event.target.value as OrderDirection,
    });
  };
  const handleCounted = (val: Inclusivity) => {
    setSearchData({
      ...searchData,
      SubmittedLineFilter: val,
    });
  };

  const handleCountedNotSubmitted = (val: Inclusivity) => {
    setSearchData({
      ...searchData,
      CountedLineFilter: val,
    });
  };

  const cancelClicked = () => {
    setSearchData(props.searchData);
    props.onCancelCallback();
  };

  const okayClicked = () => {
    if (validateBin()) {
      props.onOkayCallback(searchData);
    }
  };

  function validateBin() {
    if (
      searchData.FromBin <= searchData.ToBin ||
      searchData.FromBin == "" ||
      searchData.ToBin == ""
    ) {
      setisValidInput(true);
      return true;
    } else {
      setisValidInput(false);
      toast.error("From Bin location is greater than the To Bin location", {
        position: "top-right",
        autoClose: 2000,
        theme: "colored",
        transition: Slide,
      });
      return false;
    }
  }
  return (
    <>
      <div id="search-and-filter-modal" className={props.visibilityClassName}>
        <div className={`${props.visibilityClassName} filter-modal-contents`}>
          <div className="flex-items">
            <label>
              <h1 className="sort-and-filter-header">Sort & Filter</h1>
            </label>
          </div>
          <div className="flex-items">
            <hr></hr>
          </div>
          <div className="filter-block-container">
            <div className="right-filter-items">
              <table className="filter-option-table">
                <tbody>
                  <tr className="sort-options-row sort-by">
                    <td className="filter-option-label-cell">
                      <label className="filter-option-label">From Bin:</label>
                    </td>

                    <td className="filter-option-label-cell">
                      <input
                        id="frombin-search-box"
                        className={
                          "filter-search-box" + (isValidInput ? "" : " error")
                        }
                        type="text"
                        value={searchData.FromBin.toUpperCase().substring(0, 6)}
                        onChange={(e) =>
                          setSearchData({
                            ...searchData,
                            FromBin: e.target.value,
                          })
                        }
                      ></input>
                    </td>

                    <td className="filter-option-label-cell">
                      <label className="filter-option-label">To Bin:</label>
                    </td>

                    <td className="filter-option-label-cell">
                      <input
                        id="tobin-search-box"
                        className={
                          "filter-search-box" + (isValidInput ? "" : " error")
                        }
                        type="text"
                        value={searchData.ToBin.toUpperCase().substring(0, 6)}
                        onChange={(e) =>
                          setSearchData({
                            ...searchData,
                            ToBin: e.target.value,
                          })
                        }
                      ></input>
                    </td>
                  </tr>
                </tbody>
              </table>
              <table className="filter-option-table">
                <tbody>
                  <InclusivitySelector
                    label="Submitted :"
                    callback={(i) => handleCounted(i)}
                  />
                  <InclusivitySelector
                    label="Counted :"
                    callback={(i) => handleCountedNotSubmitted(i)}
                  />
                </tbody>
              </table>
              <div className="flex-items">
                <hr></hr>
              </div>
              <div className="flex-items">
                <h1 className="sort-and-filter-header">Sort By</h1>
              </div>
              <div className="flex-items">
                <hr></hr>
              </div>
              <table className="filter-options-table">
                <tbody>
                  <tr className="sort-options-row sort-by">
                    <td className="filter-option-label-cell">
                      <label className="filter-option-label">
                        Bin Location
                      </label>
                    </td>

                    {Object.values(OrderDirection).map((option) => (
                      <td key={option} className="filter-option-checkbox-cell">
                        <label className="checkbox-label" htmlFor={option}>
                          {option == OrderDirection.Ascending ? "A-Z" : "Z-A"}
                        </label>
                        <input
                          type="radio"
                          name="direction-group"
                          className="checkbox-style"
                          value={option}
                          checked={searchData.OrderDirection === option}
                          onChange={handleDirectionChange}
                        />
                      </td>
                    ))}
                  </tr>
                </tbody>
              </table>

              <div className="flex-items">
                <hr></hr>
              </div>
            </div>
          </div>
          <div>
            <span className="filter-modal-button-span">
              <AbstractButton
                id="cancel-button"
                text="Cancel"
                icon={<CancelIcon width="100%" height="100%" />}
                disabled={false}
                activeColor={ForegroundColorSet.Red}
                background={BackgroundColorSet.Black1}
                actionCallback={cancelClicked}
                specialClass="modal-button"
              />
              <AbstractButton
                id="filter-okay-button"
                text="Apply"
                icon={<OkayIcon width="100%" height="100%" />}
                disabled={false}
                activeColor={ForegroundColorSet.Green}
                background={BackgroundColorSet.Black1}
                actionCallback={okayClicked}
                specialClass="modal-button"
              />
            </span>
          </div>
        </div>
      </div>

      <ToastContainer />
    </>
  );
};

export default StockCheckLineFilter;
